import React, { FC, useState } from "react";
import { FormQuestionDto, FormSectionDto } from "@green0meter/api-client";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";

import { Button } from "@components/base";
import { useAddDraftTableRow } from "@api";
import { useUserStore } from "@store/user";

interface AddRowButton {
  formId: string;
  section: FormSectionDto;
  question: FormQuestionDto;
  disabled?: boolean;
}

const AddRowButton: FC<AddRowButton> = ({ formId, question, section, disabled }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { user } = useUserStore();
  const { addDraftTableRowAsync, addDraftTableRowEnabled } = useAddDraftTableRow(
    user,
    {
      formId,
      sectionCode: section.code,
      questionCode: question.code,
    },
  );

  const handleAddRow = async (): Promise<void> => {
    setLoading(true);
    await addDraftTableRowAsync();
    setLoading(false);
  };

  return (
    addDraftTableRowEnabled && (
      <Button
        variant="outlined"
        size="small"
        fullWidth
        onClick={handleAddRow}
        disabled={disabled || loading}
        startIcon={<FeatherIcon icon="plus" />}
        isLoading={loading}
      >
        {t("table.addRow")}
      </Button>
    )
  );
};

export default AddRowButton;
